import { useContext } from 'react';
import { LocaleContext, type LocaleContextValue } from './locale-context';

/**
 * The active locale and a way to change it.
 *
 * Throws outside a provider rather than falling back to a default. A silent
 * fallback would let a switcher render, look functional, and change nothing —
 * which is far harder to notice than a crash on first render.
 */
export function useLocale(): LocaleContextValue {
  const context = useContext(LocaleContext);

  if (context === undefined) {
    throw new Error('useLocale must be used within an <I18nProvider>');
  }

  return context;
}
